import * as ngCore from '@angular/core'
import * as ec from '@attain-apps/fe/web/main/lib/entity-collection'
import * as rxjs from 'rxjs'

import * as gql from './gql'
import type { TypeParams } from './types'

/** Space record API, for fetching and updating space records */
@ngCore.Injectable()
export class Api implements ec.models.Api<TypeParams> {
  /** @inheritdoc */
  public list = ec.models.Api.list.using.everything<TypeParams>(
    (context, _params) => {
      if (!context) {
        return rxjs.of([])
      }
      return gql.queries.jobTitles.executor(context)
    },
  )
}
